var React = require('react');

function Circle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#ffb563;}.cls-2{fill:#ffa746;}")),React.createElement("title",{"key":1},"circle"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("path",{"className":"cls-1","d":"M0,22A22,22,0,0,0,22,44V0A22,22,0,0,0,0,22Z","key":0}),React.createElement("path",{"className":"cls-2","d":"M44,22A22,22,0,0,0,22,0V44A22,22,0,0,0,44,22Z","key":1})]))]);
}

Circle.displayName = "Circle";

Circle.defaultProps = {"viewBox":"0 0 44 44"};

module.exports = Circle;

Circle.default = Circle;
